// src/ArrowLeftIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ArrowLeftIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m12 19-7-7 7-7" }),
      /* @__PURE__ */ jsx("path", { d: "M19 12H5" })
    ]
  }
);
var ArrowLeftIcon_default = ArrowLeftIcon;

export {
  ArrowLeftIcon_default
};
